import { BarLoader } from 'react-spinners';
import { Box, useThemeUI } from '@apia/theme';

const LinearLoader = () => {
  const theme = useThemeUI();
  return (
    <Box
      sx={{
        '*': { height: '6.5px !important' },
      }}
    >
      <Box
        sx={{
          zIndex: 'tooltip',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
        }}
        className="linearLoader"
      >
        <BarLoader width="100%" color={theme.theme.palette.primary.main} />
      </Box>
    </Box>
  );
};

export default LinearLoader;
